import React from 'react'
import './Hero.css'
// import Img1 from './heroImages/War-of-the-Vikings-game.jpg'
function Hero() {
  return (
    <div className="hero mt-4">
         
    </div>
  )
}

export default Hero